import styled from 'styled-components';

export const NFTAssetLoading = styled.div`
    display: block;
    width: 100%;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
`;
